import { IconName } from '@infotech-soe/erp-ui-kit';
import { THotKey } from '@infotech-soe/metaschema';

import {
  BuiltinCaptionType,
  Caption,
  CaptionType,
} from '../../../models/caption/Caption';
import CategoryCommandImpl from '../impl/CategoryCommandImpl';

import CategoryCommand from './CategoryCommand';

class DownloadCommand extends CategoryCommand<Record<string, any>> {
  constructor(
    commandImpl: CategoryCommandImpl<Record<string, any>>,
    private caption?: string,
    private icon?: IconName,
    private menuLabel?: string,
    private hotKey?: THotKey
  ) {
    super(commandImpl);
  }

  public async getCaption(): Promise<Caption> {
    return this.caption
      ? {
          type: CaptionType.EXTERNAL,
          caption: this.caption,
        }
      : {
          type: CaptionType.BUILT_IN,
          caption: BuiltinCaptionType.DOWNLOAD,
        };
  }

  public getIcon(): IconName {
    return this.icon ?? 'download';
  }

  public getMenuLabel(): string | undefined {
    return this.menuLabel;
  }

  public getHotKey(): THotKey | undefined {
    return this.hotKey;
  }
}

export default DownloadCommand;
